<template>
<div id="auth">
  <div class="login container">
    <el-row type="flex" justify="center">
      <el-col :md="12">
        <el-card show type="primary">
          <h1>Log In</h1>
          <br>
          <el-form>
            <el-row>
              <el-input v-model="pendingLicense" type="text" placeholder="12345">
                <template slot="prepend">License</template>
              </el-input>
            </el-row>
            <hr>
            <el-row type="flex" justify="end">
              <el-button @click="login()" type="primary" :loading="loading" :disabled="!pendingLicense">
                Log In
              </el-button>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import api from '@/lib/api'
import license from '@/lib/license'

export default {
  name: 'Auth',
  props: [
    'license'
  ],
  data() {
    return {
      loading: false,
      pendingLicense: null
    }
  },
  methods: {
    async login(license = this.pendingLicense) {
      this.loading = true
      try {
        api.setLicense(license)
        await api.me()
        this.redirect(license)
      } catch(err) {
        api.setLicense(null)
        this.showError(err)
      }
      this.loading = false
    },
    showError(err) {
      let title = err.response ? err.response.data.title : 'Error'
      let message = err.response ? err.response.data.message : err.message
      this.$message.error(`${title}: ${message}`)
    },
    redirect(newLicense) {
      license.set(newLicense)
      this.$router.push({ path: this.$route.query.to })
    }
  },
  async mounted() {
    if (!this.license) return
    await this.login(this.license)
  }
}
</script>

<style lang="scss">
#auth {
  padding: 40px 0;

  .login.container {
    padding: 150px 8px 200px 8px;
  }
}
</style>
